import { render, staticRenderFns } from "./ReceivingList.vue?vue&type=template&id=223f7be3&scoped=true&"
import script from "./ReceivingList.vue?vue&type=script&lang=js&"
export * from "./ReceivingList.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingList.vue?vue&type=style&index=0&id=223f7be3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f7be3",
  null
  
)

export default component.exports